export default "__VITE_ASSET__kiVV0cNE__"